import Cookies from 'js-cookie';

const REFRESH_TOKEN_KEY = 'refreshToken';
const isSecureContext = typeof window !== 'undefined' && window.location.protocol === 'https:';

export const setRefreshToken = (token: string, expiresAt?: string) => {
  Cookies.set(REFRESH_TOKEN_KEY, token, {
    expires: expiresAt ? new Date(expiresAt) : 14,
    path: '/',
    secure: isSecureContext,
    sameSite: 'strict',
  });
};

export const getRefreshToken = () => {
  return Cookies.get(REFRESH_TOKEN_KEY);
};

export const removeRefreshToken = () => {
  Cookies.remove(REFRESH_TOKEN_KEY, { path: '/' });
};
